module.exports = __webpack_public_path__ + "img/96.7.Chla.91f622b3.png";